module.exports = __webpack_public_path__ + "static/media/ACE-logo.3529340974e2e70f93596a5471e89203.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ACE-logo.png
// module id = 2698
// module chunks = 1